import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'app/core/services/global/global.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  langs: {name: string, cod: string}[];
  constructor(public _global: GlobalService,
     private _translate: TranslateService) {
      this.langs = [
        {name: 'ENG', cod: 'en_GB'},
        {name: 'ESP', cod: 'es_ES'},
        {name: 'CAT', cod: 'ca_ES'}
      ]
  }

  changeLang(cod: string) {
    this._translate.use(cod);
    this._global.lang = cod;
    this._global.manualLangSelected = true;
  }
}
